import { Component, Input, OnInit } from '@angular/core';
import { OfbizFormsService } from '../ofbiz-forms.service';

@Component({
  selector: 'ubs-ofbiz-view-form',
  templateUrl: './ofbiz-view-form.component.html',
  styleUrls: ['./ofbiz-view-form.component.scss']
})
export class OfbizViewFormComponent implements OnInit {
  @Input() value:any;
  @Input() componentConfig:any;
  @Input() options:any;
  fields:any[];
  viewFields:any[] = [];
  
  constructor(private ofbizFormService:OfbizFormsService) { }

  ngOnInit(): void {
    this.ofbizFormService.getForm(this.options)
    .subscribe(data => {
      this.fields = data["fields"];
      this.fields.forEach(field => {
        if(field.title != "No Condition Find" && field.title != "Update" && field.title != "Submit" && field.title != "Find"){
          if(field.name in this.value){
            field.value = this.value[field.name];
          }
          this.viewFields.push(field); 
        }

      });
      let keys = Object.keys(this.value);
      keys.forEach(key => {
        let checkField = this.fields.find(element => element.name === key);
        if(!checkField){
          let title = key.replace(/([a-z])([A-Z])/g, '$1 $2');
          this.viewFields.push({"title":title,value:this.value[key]})
        }
      })
    })
  }

}
